<template lang="pug">
.app

	loading-cover(
		v-if="isLoading"
		:message="loadingMessage"
		:image="loadingBlocks"
	)

	div(
		v-if="!isLoading"
	)

		h1 Primary Mortgage Market Survey®

		h2 U.S. weekly averages as of {{ lastUpdated }}

		app-stats.AppStats(
			v-if="chart"
			:chart="chart"
		)

		app-toolbar.AppToolbar(
			v-if="chart"
			:seriesData="data"
			:range="range"
			:chart="chart"
			@print="print"
			@download="download"
		)

		app-chart(
			:seriesData="data"
			@chart="_chart => chart = _chart"
			:range="range"
			:lastUpdated="lastUpdated"
		)

		// extra buttons
		toolbar.admin-buttons(
			v-if="config.showButtons"
		)
			toolbar-spacer(full)
			toolbar-button-group(
				label="Download for Social Media"
			)

				toolbar-button(
					@click.prevent="download('facebook')"
				) Facebook

				toolbar-button(
					@click.prevent="download('twitter')"
				) Twitter

				toolbar-button(
					@click.prevent="download('instagram')"
				) Instagram
			toolbar-spacer(full)

</template>

<script>
import $ from 'jquery';
import Iframe from '@/common/util/Iframe';
import LoadingCover from '@/common/components/LoadingCover.vue';
// import AppChartZoom from "./AppChartZoom";

import AppToolbar from './AppToolbar.vue';
import AppChart from './AppChart.vue';
import AppStats from './AppStats.vue';
import { format } from 'date-fns';
import Toolbar from '@/common/components/Toolbar.vue';
import ToolbarSpacer from '@/common/components/ToolbarSpacer.vue';
import ToolbarButton from '@/common/components/ToolbarButton.vue';
import ToolbarButtonGroup from '@/common/components/ToolbarButtonGroup.vue';

import loadingBlocks from '@/common/images/loading-blocks@2x.gif';

import PMMSWorker from '../worker.js?worker';

const shareDimensions = {
	facebook: [600, 315],
	twitter: [600, 300],
	instagram: [540, 540]
};

export default {

	name: 'PMMS',

	props: [
		'baseurl',
		'config'
	],

	components: {
		LoadingCover,
		AppToolbar,
		AppChart,
		AppStats,
		Toolbar,
		ToolbarSpacer,
		ToolbarButton,
		ToolbarButtonGroup
		// 'app-table': AppTable,
		// 'app-deal': AppDeal,
	},

	data() {
		// need to get a url for the worker
		const worker = new PMMSWorker();

		return {
			iframe: null,
			asPDF: false,
			range: { min: null, max: null },
			loader: worker,
			data: {},
			isLoading: true,
			loadingMessage: "Loading...",
			loadingBlocks,
			chart: null
		}
	},

	computed: {
		lastUpdated() {
			if (!this.data) {
				return null;
			}
			return format(this.data.rate30[this.data.rate30.length - 1].date, 'MM/dd/yyyy');
		}
	},

	mounted() {
		this.iframe = new Iframe();
		this.iframe.watchDimensions();
	},

	watch: {
		isLoading(v) {
			if (!v) {
				this.loadingMessage = "Loading...";
			}
		},
		chart(c) {
			if (c) {
				// this.setExtremes
			}
		}
	},

	created() {
		this.loader.addEventListener('message', e => {
			this.data = e.data.data;
			this.isLoading = false;
		});
		this.loader.postMessage({
			cmd: 'load',
			config: this.config
		});
	},

	methods: {
		
		print() {
			let svg = this.chart.getSVGForExport({
				sourceWidth: 842,
				sourceHeight: 595,
				formAttributes: {
					width: 842,
					height: 595
				}
			});
			let $svg = $(svg);
			let $div = $('<div />')
				.appendTo('body')
				.css({ display: 'none' })
				.addClass('printable-chart');

			$svg.appendTo($div);

			// lets also add it to a test svg
			// this.$refs.svgTest.innerHTML = '';
			// $svg.clone().appendTo(this.$refs.svgTest);

			let $style = $('<style type="text/css" media="print">@page{ size: landscape; } body>*{ display: none !important; } body > .printable-chart { display: block !important; } body > .printable-chart > svg { max-width: 100%; width: 100%; height: auto; }</style>');
			$style.appendTo('body');
			window.focus();
			setTimeout(function give_it_a_sec_to_load_the_image() {
				window.print();

				// allow the browser to prepare before reverting
				setTimeout(function () {

					$div.remove();
					$style.remove();
				}, 1000);
			}, 100);
		},

		download(size = 'default') {
			const args = {
				allowHTML: true,
				type: 'image/png',
				
				fetchOptions: {
					cors: false
				}
			};

			switch (size) {
				case 'twitter':
					Object.assign(args, {
						sourceWidth: shareDimensions.twitter[0],
						sourceHeight: shareDimensions.twitter[1],
						formAttributes: {
							width: shareDimensions.twitter[0],
							height: shareDimensions.twitter[1]
						}
					});
					break;

				case 'facebook':
					Object.assign(args, {
						sourceWidth: shareDimensions.facebook[0],
						sourceHeight: shareDimensions.facebook[1],
						formAttributes: {
							width: shareDimensions.facebook[0],
							height: shareDimensions.facebook[1]
						}
					});
					break;

				case 'instagram':
					Object.assign(args, {
						sourceWidth: 540, //shareDimensions.instagram[0],
						sourceHeight: 540, //shareDimensions.instagram[1],
						scale: 2.5
					});
					break;
			}
			// this.chart.exportChartLocal(args);
			this.chart.exportChart(args);
		},
		setRange(min, max) {
			this.range.min = min;
			this.range.max = max;
		}
	}
};
</script>


<style lang="scss">
// set the global font variable
$font-family: canada-type-gibson, Arial, Lucida Sans Unicode, sans-serif;
@use '@/common/scss/global';
@use '@/pmms/scss/app.scss';


.app {
	min-height: 360px;
}

.AppToolbar {
	margin-bottom: 15px;
}
</style>

<style lang="scss" scoped>
h1 {
	margin-bottom: 0;
	font-weight: 500;
	font-size: 1.9rem;
}

h2 {
	font-weight: 300;
	margin-bottom: 1em;
	color: #717171;
}
</style>
